import { CalendarDuration } from "PFApp/activities/engagement_blueprint/components/availability_table/types";
import {
  DEFAULT_FUTURE_MONTHS_VISIBILITY_LIMIT,
  DEFAULT_PAST_MONTHS_VISIBILITY_LIMIT
} from "PFApp/constants/availability";
import { utc } from "PFCore/helpers/date";
import { useMyAccountInfo } from "PFCore/hooks/queries/account/use_my_account_info";
import { useDateFormatter } from "PFCore/hooks/use_date_formatter";
import { useMemo } from "react";

const MONDAY = 1;
const SUNDAY = 7;

export const useVisibilityLimitedCalendarDuration = (): CalendarDuration => {
  const {
    data: { availability }
  } = useMyAccountInfo();
  const { formatISODate } = useDateFormatter();

  const pastMonths = availability?.past_months_visibility_limit ?? DEFAULT_PAST_MONTHS_VISIBILITY_LIMIT;
  const futureMonths = availability?.future_months_visibility_limit ?? DEFAULT_FUTURE_MONTHS_VISIBILITY_LIMIT;

  return useMemo(() => {
    const today = utc();

    const startDate = today.clone().subtract(pastMonths, "months");
    const weekStart = startDate.isoWeekday() === MONDAY ? startDate : startDate.clone().startOf("isoWeek");

    const endDate = today.clone().add(futureMonths, "months");
    const weekEnd = endDate.isoWeekday() === SUNDAY ? endDate : endDate.clone().endOf("isoWeek");

    return {
      start: formatISODate(weekStart),
      end: formatISODate(weekEnd)
    };
  }, [pastMonths, futureMonths, formatISODate]);
};
